import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/contexts/auth-context';
import { usePlayerTeam } from '@/hooks/use-coach';
import { initPostHog, capturePageview, identifyUser, resetUser, setGroup } from '@/lib/analytics/posthog';

export default function AnalyticsBindings() {
  const [location] = useLocation();
  const { user, session, isAuthenticated } = useAuth();
  const { data: teamData } = usePlayerTeam();

  // Initialize once
  useEffect(() => {
    initPostHog();
  }, []);

  // Capture SPA pageviews on route change
  useEffect(() => {
    try {
      const path = `${window.location.pathname}${window.location.search}`;
      capturePageview(path);
    } catch {}
  }, [location]);

  // Identify user when authenticated with Supabase ID; reset on logout
  useEffect(() => {
    try {
      if (isAuthenticated && session?.user?.id) {
        identifyUser(session.user.id, {
          email: session.user.email || undefined,
          name: (session.user.user_metadata?.name || session.user.user_metadata?.full_name) ?? undefined,
          planTier: user?.planTier,
          accountType: user?.accountType,
          credits: user?.credits,
          bonusCredits: user?.bonusCredits,
          totalReferrals: user?.totalReferrals,
          consultationCredits: user?.consultationCredits,
          hasTeam: !!teamData?.hasTeam,
        });
      } else {
        resetUser();
      }
    } catch {}
  }, [isAuthenticated, session?.user?.id, user?.planTier, user?.accountType, user?.credits, user?.bonusCredits, user?.totalReferrals, user?.consultationCredits, teamData]);

  // Associate user with team group when they have a team
  useEffect(() => {
    try {
      if (isAuthenticated && teamData?.hasTeam && teamData.team?.id) {
        setGroup('team', String(teamData.team.id), {
          name: teamData.team.name,
        });
      }
    } catch {}
  }, [isAuthenticated, teamData]);

  return null;
}